import { Image } from "antd";
import { useTranslation } from "react-i18next";
import boy1 from "./components/layout1/images/boy1.png";
import boy2 from "./components/layout1/images/boy2.png";
import dogcat from "./components/layout1/images/dogcat.png";
import girl1 from "./components/layout1/images/girl1.png";
import orangeGirl from "./components/layout1/images/orangeGirl.png";
import skateboard from "./components/layout1/images/skateboard.png";
import styles from "./style.module.scss";

const BrandIntro = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.brandContainer}>
      <section>
        <div
          title={`${process.env.REACT_APP_PROD_NAME_DISPLAY}-home`}
          aria-label={`${process.env.REACT_APP_PROD_NAME_DISPLAY}-home`}
          className={styles.topSection}
          style={{
            backgroundImage: `url('/images/brands/${process.env.REACT_APP_PROD_NAME_DEV}/home/home_bg.png')`,
          }}
        >
          <div className={styles.topContainer}>
            <div className={styles.brandSlogan}>
              <div>{process.env.REACT_APP_PROD_NAME_DEV}</div>
              <div> {t("brand.slogan")}</div>
            </div>
            <div className={styles.topImage}>
              <Image
                alt="skateboard"
                src={skateboard}
                preview={false}
                className={styles.skateboard}
              />
            </div>
          </div>
        </div>
      </section>
      <section>
        <div className={styles.middleSection}>
          <div className={styles.goImage}>
            <Image alt="orangeGirl" src={orangeGirl} preview={false} />
          </div>
          <div
            className={styles.middleText}
            dangerouslySetInnerHTML={{
              __html: t("brand.brandStory", {
                brand: process.env.REACT_APP_PROD_NAME_DEV,
              }),
            }}
          ></div>
        </div>
      </section>
      <section>
        <div className={styles.bottomSection}>
          <div className={styles.first}>
            {t("brand.slogan.one")}
            <div className={styles.firstImg}>
              <Image alt="boy1" src={boy1} preview={false} />
            </div>
          </div>
          <div className={styles.second}>
            {t("brand.slogan.two")}
            <div className={styles.secondImg}>
              <Image alt="girl1" src={girl1} preview={false} />
            </div>
          </div>
          <div className={styles.third}>
            {t("brand.slogan.three")}
            <div className={styles.thirdImg}>
              <Image alt="boy2" src={boy2} preview={false} />
            </div>
          </div>
          <div className={styles.forth}>
            {t("brand.slogan.four")}
            <div className={styles.forthImg}>
              <Image alt="dogcat" src={dogcat} preview={false} />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default BrandIntro;
